module.exports = "/images/empty_cart.jpg";